import React, { useState, useEffect } from "react";
import { Nav, Navbar, Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import logo from "./assets/image/9rlogo.webp";
import logoLight from "./assets/image/9r logo.webp";
import { Helmet } from "react-helmet-async";

const Header = (props) => {
  const [expanded, setExpanded] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const pageTitle = "9R NFC Card - Your NFC Solution";
  const pageDescription =
    "Get high-quality NFC cards for secure, efficient, and contactless solutions. 9R NFC Card offers cutting-edge NFC technology for businesses.";
  const pageKeywords =
    "9R NFC Card, NFC solutions, NFC cards, secure NFC cards, contactless technology, RFID cards";

  return (
    <>
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={pageDescription} />
        <meta name="keywords" content={pageKeywords} />
        <meta property="og:title" content={pageTitle} />
        <meta property="og:description" content={pageDescription} />
        <meta property="og:image" content={logo} />
        <meta property="og:url" content="https://9rnfc.com/" />
        <meta name="twitter:title" content={pageTitle} />
        <meta name="twitter:description" content={pageDescription} />
      </Helmet>

      <div className="d-none d-lg-block">
        <div className={`header_navbar ${props.name === "AiContentStudio" ? "ai-premium-topbar" : ""}`}>
          <div className="container">
            <div className="row">
              <div className="col-lg-6 d-flex align-items-center">
                <div className="d-flex align-self-center">
                  <div className="d-flex align-iteam-center">
                    <i className="lni lni-phone text-light align-self-center me-2"></i>
                    <a
                      href="tel:+91 9925615191"
                      className="text-light text-start fw-500"
                    >
                      +91 992 561 5191
                    </a>
                  </div>
                  <div className="d-flex align-iteam-center">
                    <i className="lni lni-envelope text-light align-self-center ps-3 pe-2"></i>
                    <a
                      href="mailto:9rnfccard@gmail.com"
                      className="text-light text-start fw-500"
                    >
                      9rnfccard@gmail.com
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 d-flex align-items-center justify-content-end">
                <span className="text-light align-self fw-500 d-flex">
                  <a
                    className="d-flex align-items-center"
                    href="https://api.whatsapp.com/send?phone=+919925615191&amp;text=Hi+9|R,+I+want+some+more+information+about+your+services.+Please+reply+soon."
                    target="_blank"
                    rel="noreferrer"
                  >
                    <i className="text-light lni lni-whatsapp me-3"></i>
                  </a>

                  <a
                    className="d-flex align-items-center"
                    href="https://www.facebook.com/profile.php?id=61563096922232"
                  >
                    <i className="text-light lni lni-facebook-original me-3"></i>
                  </a>

                  <a
                    className="d-flex align-items-center"
                    href="https://www.instagram.com/9rnfc_com?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                    target="_blank"
                    rel="noreferrer"
                  >
                    <i className="text-light lni lni-instagram-original me-3"></i>
                  </a>

                  <a
                    href="https://www.linkedin.com/in/9r-nfc-b63aaa319"
                    className="d-flex align-items-center"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <i className="text-light lni lni-linkedin-original text-white"></i>
                  </a>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Navbar
        expanded={expanded}
        expand="xl"
        className={`topnavmenu sticky-top ${props.name === "AiContentStudio" ? "ai-premium-nav" : ""} ${isScrolled ? "scrolled" : ""}`}
      >
        <Container className="container">
          <Navbar.Brand href="./" className="navbar-brand">
            <img
              src={props.name === "AiContentStudio" ? logoLight : logo}
              alt="9R NFC Card - Secure and Contactless NFC Technology"
              className="nav_logo"
            />
          </Navbar.Brand>
          <Navbar.Toggle
            aria-controls="basic-navbar-nav"
            onClick={() => setExpanded(!expanded)}
          />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav
              className="navbar-nav mx-auto"
              onClick={() => setExpanded(false)}
            >
              <Link
                to={"/"}
                className={
                  props.name === "home" ? "nav-btns m-1 active" : "nav-btns m-1"
                }
              >
                Home
              </Link>
              <Link
                to={"/Products"}
                className={
                  props.name === "Products"
                    ? "nav-btns m-1 active"
                    : "nav-btns m-1"
                }
              >
                Products
              </Link>
              <Link
                to={"/About-Us"}
                className={
                  props.name === "About-us"
                    ? "nav-btns m-1 active"
                    : "nav-btns m-1"
                }
              >
                About Us
              </Link>

              <Link
                to={"/Services"}
                className={
                  props.name === "Services"
                    ? "nav-btns m-1 active"
                    : "nav-btns m-1"
                }
              >
                Services
              </Link>
              <Link
                to={"/Projects"}
                className={
                  props.name === "Projects"
                    ? "nav-btns m-1 active"
                    : "nav-btns m-1"
                }
              >
                Projects
              </Link>
              <Link
                to={"/QRCodeGenerator"}
                className={
                  props.name === "QRCodeGenerator" ? "nav-btns m-1 active" : "nav-btns m-1"
                }
              >
                QR Generator
              </Link>
              <Link
                to={"/Blog"}
                className={
                  props.name === "Blog" ? "nav-btns m-1 active" : "nav-btns m-1"
                }
              >
                Blog
              </Link>

              <Link
                to={"/Contact"}
                className={
                  props.name === "Contact"
                    ? "nav-btns m-1 active"
                    : "nav-btns m-1"
                }
              >
                Contact
              </Link>
            </Nav>
            <Link to={"/ai-content-studio"} className="ms-auto mt-lg-0 mt-1" style={{ textDecoration: 'none' }}>
              <p className="btn-history px-4 py-2 mb-0 text-dark">
                <i className="fa-solid fa-wand-magic-sparkles me-2"></i>
                AI Studio
              </p>
            </Link>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
};

export default Header;
